import { useState, useEffect } from 'react';
import { useWindowSize } from 'react-use';
import { breakpoints } from '../constants';

const useIsMobile = () => {
  const { width } = useWindowSize();
  const [state, setState] = useState({ isSm: false, isXs: false });

  useEffect(() => {
    if (width < breakpoints.MD && !(width < breakpoints.SM)) {
      setState({ isSm: true, isXs: false });
    } else if (width < breakpoints.SM) {
      setState({ isSm: true, isXs: true });
    } else {
      setState({ isSm: false, isXs: false });
    }
  }, [width]);

  return state;
};

export default useIsMobile;
